import { InvoiceEvidenceView } from '../../../types/entity-types';

export const getEvidenceSuggestedTransactions = (evidence?: InvoiceEvidenceView) => {
  if (!evidence) {
    return [];
  }

  return evidence.suggestedTransactions?.reduce<string[]>((acc, value) => {
    if (acc.includes(value.transactionId)) {
      return acc;
    }

    return [...acc, value.transactionId];
  }, []);
};
